import {
  ArrowsPointingOutIcon,
  MinusIcon,
  PlusIcon,
  EllipsisVerticalIcon,
} from '@heroicons/react/20/solid';

export interface Props {
  zoomIn: () => void;
  zoomOut: () => void;
  fit: () => void;
  openMenu?: () => void;
}

function MapButtons({ zoomIn, zoomOut, fit, openMenu }: Props) {
  return (
    <div className="Trail_buttons">
      <button
        onClick={() => zoomIn()}
        type="button"
        aria-label="Zoom in"
        className="bg-mt-surface hover:bg-mt-surface-2 focus-visible:outline-mt-primary mb-5 size-12 rounded-full p-3 text-white shadow focus-visible:outline-2 focus-visible:outline-offset-2"
      >
        <PlusIcon className="text-mt-ink-muted size-6" aria-hidden="true" />
      </button>
      <button
        onClick={() => zoomOut()}
        type="button"
        aria-label="Zoom out"
        className="bg-mt-surface hover:bg-mt-surface-2 focus-visible:outline-mt-primary mb-5 size-12 rounded-full p-3 text-white shadow focus-visible:outline-2 focus-visible:outline-offset-2"
      >
        <MinusIcon className="text-mt-ink-muted size-6" aria-hidden="true" />
      </button>
      <button
        onClick={() => fit()}
        type="button"
        aria-label="Fit trail to screen"
        className="bg-mt-surface hover:bg-mt-surface-2 focus-visible:outline-mt-primary mb-5 size-12 rounded-full p-3 text-white shadow focus-visible:outline-2 focus-visible:outline-offset-2"
      >
        <ArrowsPointingOutIcon
          className="text-mt-ink-muted size-6"
          aria-hidden="true"
        />
      </button>
      {openMenu && (
        <button
          onClick={() => openMenu()}
          type="button"
          aria-label="Open menu"
          className="bg-mt-surface hover:bg-mt-surface-2 focus-visible:outline-mt-primary size-12 rounded-full p-3 text-white shadow focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          <EllipsisVerticalIcon
            className="text-mt-ink-muted size-6"
            aria-hidden="true"
          />
        </button>
      )}
    </div>
  );
}

export default MapButtons;
